import { Divider } from './Divider';
import { Item } from './Item';
import { Menu } from './Menu';
import { ResourceHubLink } from './ResourceHubLink';
import { Section } from './Section';
import { TeamSelector } from './TeamSelector';

export const Navigation = {
  Divider,
  Item,
  Menu,
  ResourceHubLink,
  Section,
  TeamSelector,
};
